import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { FileIcon } from "components/old-data-box-components";
import { useActionHook, useModals } from "hooks";
import { IFile } from "store/types";

import { useDealActions } from "../../../store";
import { bytesToMb } from "../../../utils/files";

export const FileDelete: React.FC<{ data: IFile | null; cb?: () => void }> = ({ data: file, cb }) => {
  const { closeDeleteFileModal } = useModals();

  const { deleteFileAction } = useDealActions();

  const { action: deleteQuestionFilesAction, loading } = useActionHook(deleteFileAction, {
    onSuccess: () => {
      closeDeleteFileModal();
      cb?.();
    }
  });

  if (!file) {
    return <></>;
  }

  const sizeInMb = bytesToMb(file.size_in_bytes);

  const actionDeleteSeparator = async () => {
    await deleteQuestionFilesAction(file);
  };

  return (
    <Dialog
      open={!!file}
      onClose={closeDeleteFileModal}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "10px",
          width: "800px",
          maxWidth: "90vw"
        }
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "50px",
          bgcolor: "#edf1f9",
          color: "#0a3142",
          borderRadius: "10px 10px 0 0",
          px: "34px",
          py: 0
        }}
      >
        <Typography sx={{ fontSize: "20px", letterSpacing: "0.2px", fontWeight: "bold", color: "#0a3142" }}>
          Delete File
        </Typography>
        <IconButton onClick={closeDeleteFileModal} aria-label="Close delete dialog">
          <CloseIcon sx={{ color: "#0a3142" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          height: "320px",
          padding: "38px 45px 30px 45px !important",
          bgcolor: "#ffffff",
          borderRadius: "0 0 10px 10px"
        }}
      >
        <Stack sx={{ height: "100%" }} justifyContent="space-between">
          <Box>
            <Typography sx={{ fontSize: "20px", color: "#173c4c", mb: "38px" }}>
              Are you sure you want to delete the file:
            </Typography>
            <Stack direction="row" alignItems="flex-start" spacing={2}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <FileIcon type={file.type} />
              </Box>
              <Box>
                <Typography sx={{ fontWeight: 500, fontSize: "15px", color: "#0a3142", mb: "7px" }}>
                  {file.name}
                </Typography>
                <Typography sx={{ fontSize: "15px", color: "#597380" }}>{sizeInMb}MB</Typography>
              </Box>
            </Stack>
          </Box>
          <Box>
            <Box sx={{ width: "100%", height: "1px", bgcolor: "#bdbdbd", mb: "24px" }} />
            <Stack direction="row" justifyContent="flex-end" alignItems="center">
              <Button
                variant="contained"
                onClick={actionDeleteSeparator}
                disabled={loading}
                sx={{ textTransform: "none", mr: "20px" }}
              >
                Delete
              </Button>
              <Button
                variant="outlined"
                onClick={closeDeleteFileModal}
                disabled={loading}
                sx={{ textTransform: "none" }}
              >
                Cancel
              </Button>
            </Stack>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
